import { FileSpreadsheet, FileText, Printer } from 'lucide-react';
import { cn } from '../utils/cn';

interface ExportButtonGroupProps {
  onExcel?: () => void;
  onPdf?: () => void;
  onPrint?: () => void;
  compact?: boolean;
  className?: string;
}

export default function ExportButtonGroup({ onExcel, onPdf, onPrint, compact, className }: ExportButtonGroupProps) {
  const t = (k: string) => k.split('.').pop() ?? k;

  const btnClass = cn(
    'flex items-center gap-1.5 rounded-lg border border-border px-2.5 py-1.5 text-xs font-medium text-content-secondary hover:bg-surface-card-hover transition-colors',
    compact && 'px-1.5 py-1'
  );

  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      {onExcel && (
        <button onClick={onExcel} className={btnClass} title={t('export.excel')}>
          <FileSpreadsheet size={14} />
          {!compact && <span>{t('export.excel')}</span>}
        </button>
      )}
      {onPdf && (
        <button onClick={onPdf} className={btnClass} title={t('export.pdf')}>
          <FileText size={14} />
          {!compact && <span>{t('export.pdf')}</span>}
        </button>
      )}
      {onPrint && (
        <button onClick={onPrint} className={btnClass} title={t('export.print')}>
          <Printer size={14} />
          {!compact && <span>{t('export.print')}</span>}
        </button>
      )}
    </div>
  );
}
